import { styled } from 'styled-components';
import {
  BodyHeavy,
  BodyLight,
  Button,
  CaptionHeavy,
  Colors,
  H3Heavy,
  MediaQuery,
  Skeleton,
  SmallLight,
  TextSkeleton,
  Theme,
} from '@pelando/components';
import { ComparatorIcon } from '@/presentation/components/ComparatorIcon';

export const Container = styled.div`
  background-color: rgb(${Theme.colors.Juliet});

  @media ${MediaQuery.SCREEN_LG_UP} {
    border: 1px solid rgb(${Theme.colors.Golf});
    border-radius: 16px;
  }
`;

export const ButtonSkeleton = styled(Skeleton)`
  border-radius: 36px;
  width: 100%;
  max-height: 32px;
  max-width: 232px;
  min-height: 32px;

  @media ${MediaQuery.SCREEN_SM} {
    max-width: 100%;
  }
`;

export const CustomButton = styled(Button)`
  ${CaptionHeavy}
  display: flex;
  width: 100%;
  column-gap: 4px;
  border-radius: 36px;
  align-items: center;
  max-height: 32px;
  max-width: 232px;
  padding: 8px 0;

  i {
    font-size: 24px;
  }

  @media ${MediaQuery.SCREEN_SM} {
    max-width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  gap: 8px;

  & > ${CustomButton}, ${ButtonSkeleton} {
    display: none;
  }

  @media ${MediaQuery.SCREEN_LG_UP} {
    padding: 24px;
  }

  @media ${MediaQuery.SCREEN_XL} {
    & > ${CustomButton}, ${ButtonSkeleton} {
      display: flex;
    }
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const TitleContainer = styled.div`
  ${BodyHeavy}
  display: flex;
  align-items: center;

  * {
    ${BodyHeavy}
  }

  @media ${MediaQuery.SCREEN_LG_UP} {
    ${H3Heavy}

    * {
      ${H3Heavy}
    }
  }
`;

export const SubtitleContainer = styled.div`
  ${SmallLight}
  color: rgb(${Colors.Gray});

  @media ${MediaQuery.SCREEN_LG_UP} {
    ${BodyLight}
  }
`;

export const CustomComparatorIcon = styled(ComparatorIcon)`
  margin-right: 8px;
`;

export const Footer = styled.div`
  padding: 16px;

  @media ${MediaQuery.SCREEN_XL} {
    display: none;

    & > ${CustomButton}, ${ButtonSkeleton} {
      display: none;
    }
  }
`;

export const TitleSkeleton = styled(TextSkeleton)`
  width: 332px;
  height: 24px;
`;

export const SubtitleSkeleton = styled(TextSkeleton)`
  width: 200px;
  height: 20px;
`;
